export default __webpack_public_path__ + "static/media/howTo1.f8b439f7.svg";